import Accident from './Accident';

export default Accident;
